import React, { useState } from 'react';
import './JobMonitoringTable.css';
import { Button } from 'antd';
import Selector from '../selector/selector';
import { isEmpty } from '../../../utils/functionUtils';
import { useNavigate } from 'react-router-dom';
import CrossIcon from "../../../assets/icons/cross-icon";
import API from "../../../api";
import moment from "moment";
import ActionTypes from "../../../store/actionTypes";
import { useCentralStore } from "../../../store/appContext";
import Popup from '../popup/popup';
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import resources from "../resources.json";
import { useEffect } from 'react';
import "./table.css"
import Spinner from "../spinner/spinner";


const JobMonitoringTable = () => {
    const navigate = useNavigate();
    const [selectedRegion, setSelectedRegion] = useState("All");
    const [selectedStatus, setSelectedStatus] = useState("All");
    const [selectedDateFilter, setSelectedDateFilter] = useState("Last 30 mins");
    const [selectedDate, setSelectedDate] = useState(moment(new Date()).format("YYYY-MM-DD"));  
    const [jobNameOptions, setJobNameOptions] = useState([]);
    const [showErrorPopup, setShowErrorPopup] = useState(false);
    const [selectedErrorMessage, setSelectedErrorMessage] = useState("");
    const [selectedJobName, setSelectedJobName] = useState("All");
    const [
        {
            userData,
            userDetails,
            GetJobMonitoringReportSuccess,
            loading
        },
        dispatch,
    ] = useCentralStore();
    const [filterData, setFilterData] = useState(GetJobMonitoringReportSuccess);
    const failedCount = filterData?.filter((item)=> item?.JobStatus?.toLowerCase()?.includes("failed"))?.length || 0;
    const setLoading = (action) => {
        dispatch({ type: ActionTypes.SET_LOADING, payload: action });
    };


    const handleDateChange = (date) => {
        const formattedDate =  moment(date).format("YYYY-MM-DD");
        setSelectedDate(formattedDate);
    }

    const handleSearch = () => {
        setSelectedStatus("All");
        setSelectedRegion("All");
        setSelectedJobName("All");
        GetJobMonitoringDetails();
    };


    const sortedData = filterData && filterData.sort((a, b) => {
        const statusA = a["Last Run status"] ? a["Last Run status"].toLowerCase() : '';
        const statusB = b["Last Run status"] ? b["Last Run status"].toLowerCase() : '';

        if (statusA === 'failed' && statusB !== 'failed') {
            return -1;
        }
        if (statusA !== 'failed' && statusB === 'failed') {
            return 1;
        }
        return 0;
    });

    useEffect(() => {
        GetJobMonitoringDetails();
    }, []);

    const GetJobMonitoringDetails = async (val) => {
        let selectedDuration = val ? val : selectedDateFilter;
        let StartDate = moment(new Date()).subtract(1, 'days').utc().format("YYYY-MM-DD HH:mm:ss");
        if(selectedDuration === "Last 30 mins"){
            StartDate = moment(new Date()).subtract(30, 'minutes').utc().format("YYYY-MM-DD HH:mm:ss")
        } 
        else if(selectedDuration === "Last 1 hour"){
            StartDate = moment(new Date()).subtract(1, 'hours').utc().format("YYYY-MM-DD HH:mm:ss")
        }
        else if(selectedDuration === "Last 4 hours"){
            StartDate = moment(new Date()).subtract(4, 'hours').utc().format("YYYY-MM-DD HH:mm:ss")
        }
        else if(selectedDuration === "Last 7 days"){
            StartDate = moment(new Date()).subtract(7, 'days').utc().format("YYYY-MM-DD HH:mm:ss")
        }
        else{
            StartDate = moment(new Date()).subtract(1, 'days').utc().format("YYYY-MM-DD HH:mm:ss"); 
        }

        let payload = {
            "StartJobDate": StartDate,
            "EndJobDate": moment(new Date()).utc().format("YYYY-MM-DD HH:mm:ss")
        }
        setLoading(true)
        API[ActionTypes.GET_AI_JOBMONITORING_REPORT](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
            .then(({ data }) => {
                setLoading(false);
                if (data) {
                    const data1 = data?.GetJobDetailsResponse
                    const mergedData = [...data1?.FailedJobResult, ...data1?.CompletedJobResult]

                    dispatch({
                        type: ActionTypes.GET_AI_JOBMONITORING_REPORT_SUCCESS,
                        payload: mergedData
                    });

                    
                    const uniqueJobNames = [...new Set(mergedData?.map(item => item.JobName))]; 

                    const jobNameFilteredData = uniqueJobNames?.map((item) => {
                        return {name: item, value: item}
                        })
                    jobNameFilteredData.unshift({ name: "All", value: "All" });
                    setJobNameOptions(jobNameFilteredData);
                    setFilterData(mergedData);

                }
            })
            .catch((err) => {
                setLoading(false);
                dispatch({
                    type: ActionTypes.GET_AI_JOBMONITORING_REPORT_FAILURE,
                    payload: err,
                });
                dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
                let _payload = {
                    level: resources.POST_LOGGER_ERROR,
                    category: resources.POST_LOGGER_API,
                    ApiName: resources.POST_LOGGER_APINAME,
                    message: {
                        error: err,
                        info: {
                            idToken: "",
                        },
                    },
                };
                API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
            });
    }

    const handleRetrigger = async (item) => {
        let payload = {
            "Cluster": item?.Cluster,
            "TaskName": item?.TaskName,
            "JobName": item?.JobName,
            "Region": item?.Region,
            "JobMoniteringId": item?.JobMoniteringId
        }
        setLoading(true)
        API[ActionTypes.GET_JOBMONITORING_RETRIGGER](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
            .then(({ data }) => {
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                dispatch({
                    type: ActionTypes.GET_JOBMONITORING_RETRIGGER_FAILURE,
                    payload: err,
                });
                dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
                let _payload = {
                    level: resources.POST_LOGGER_ERROR,
                    category: resources.POST_LOGGER_API,
                    ApiName: resources.POST_LOGGER_APINAME,
                    message: {
                        error: err,
                        info: {
                            idToken: "",
                        },
                    },
                };
                API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
            });
    }


    const handleClearFilter = () => {
        setSelectedStatus("All");
        setSelectedRegion("All");
        setSelectedDateFilter("Last 30 mins");
        setSelectedJobName("All");
        GetJobMonitoringDetails();
       
        setSelectedDate(moment(new Date()).format("YYYY-MM-DD"));
    }

   


    const handleRegionSelect = (val) => {
        const filterData = GetJobMonitoringReportSuccess && GetJobMonitoringReportSuccess.filter((item) => {
            const regionMatch = val && val !== "All" ? (item?.Region?.toLowerCase() === val?.toLowerCase()) : true;
            const statusMatch = selectedStatus && selectedStatus !== "All" ? item?.JobStatus?.toLowerCase() === selectedStatus.toLowerCase() : true;
            const jobNameMatch = selectedJobName && selectedJobName !== "All" ? item?.JobName?.toLowerCase() === selectedJobName.toLowerCase() : true;
            return regionMatch && statusMatch && jobNameMatch;
        });
        setFilterData(filterData);
        setSelectedRegion(val);
    };

    const handleStatusSelect = (val) => {
        const filterData = GetJobMonitoringReportSuccess && GetJobMonitoringReportSuccess.filter((item) => {
            const regionMatch = selectedRegion && selectedRegion !== "All" ? item?.Region?.toLowerCase() === selectedRegion.toLowerCase() : true;
            const statusMatch = val && val !== "All" ? item?.JobStatus?.toLowerCase()?.includes(val?.toLowerCase()) : true;
            const jobNameMatch = selectedJobName && selectedJobName !== "All" ? item?.JobName?.toLowerCase() === selectedJobName.toLowerCase() : true;
            return regionMatch && statusMatch && jobNameMatch;
        });

        setFilterData(filterData);
        setSelectedStatus(val);
    };

    const handleGoBack = () => {
        navigate(-1);
    }

    const handleViewError = (item) => { 
        setShowErrorPopup(true);
        setSelectedErrorMessage(item?.ErrorMessage);
    }

    const handleDateFilterSelect = (val) => {
    setSelectedDateFilter(val);
    setSelectedJobName("All");
    setSelectedRegion("All");
    setSelectedStatus("All");
    GetJobMonitoringDetails(val);
    }

    const handleJobNameSelect = (val) => {
        const filterData = GetJobMonitoringReportSuccess && GetJobMonitoringReportSuccess.filter((item) => {
            const regionMatch = selectedRegion && selectedRegion !== "All" ? item?.Region?.toLowerCase() === selectedRegion.toLowerCase() : true;
            const statusMatch = selectedStatus && selectedStatus !== "All" ? item?.JobStatus?.toLowerCase() === selectedStatus.toLowerCase() : true;
            const jobNameMatch = val && val !== "All" ? (item?.JobName?.toLowerCase() === val?.toLowerCase()) : true;
            return regionMatch && statusMatch && jobNameMatch;
        });
        setFilterData(filterData);
        setSelectedJobName(val);
    }

    // Get unique job names and their counts
    const jobNameCounts = filterData ? filterData.reduce((acc, item) => {
        acc[item.JobName] = (acc[item.JobName] || 0) + 1;
        return acc;
    }, {}) : {};
    const uniqueJobNameData = filterData ? filterData.filter((item, index, self) =>
        index === self.findIndex((t) => t.JobName === item.JobName)
    ) : [];
    // State for popup data
    const [popupJobData, setPopupJobData] = useState([]);
    const [showJobPopup, setShowJobPopup] = useState(false);
    // Handler for arrow click
    const handleShowJobPopup = (jobName) => {
        const jobData = filterData.filter(item => item.JobName === jobName);
        setPopupJobData(jobData);
        setShowJobPopup(true);
    };

    // State for expanded job names (for inline expand/collapse)
    const [expandedJobNames, setExpandedJobNames] = useState([]);

    // Handler for arrow click (expand/collapse inline rows)
    const handleToggleExpand = (jobName) => {
        setExpandedJobNames((prev) =>
            prev.includes(jobName)
                ? prev.filter((name) => name !== jobName)
                : [...prev, jobName]
        );
    };

    return (
        <>
            {loading && <Spinner showOverlay={true} />}

            <div className="container mx-auto p-4 table-container rounded-xl text-black relative">
                <header>
                    <h2 className="text-2xl font-bold mb-4">Job Monitoring</h2>

                    <CrossIcon
                        className="absolute top-3 right-3 m-2 cursor-pointer w-4 h-4"
                        onClick={handleGoBack}
                    />

                    <div className="pr-4 mt-4 mb-4 flex justify-between">
                        <div className=" flex gap-4">
                          
                           
                            <Selector
                                key="JobName Dropdown"
                                options={jobNameOptions}
                                label="JobName"
                                value={selectedJobName}
                                onSelect={handleJobNameSelect}
                                placeholder="JobName"
                                isAIReport={true}
                                isJobMonitoring={true}
                                className="absolute top-0 mt-10 bg-black border border-gray-300 rounded-lg p-2"
                                style={{
                                    zIndex: 1000
                                }}
                            />
                            <Selector
                                key="Region Dropdown"
                                options={[
                                    { name: "All", value: "All" },
                                    { name: "ANZ", value: "ANZ" },
                                    { name: "SEA", value: "SEA" },
                                ]}
                                label="Region"
                                value={selectedRegion}
                                onSelect={handleRegionSelect}
                                placeholder="Region"
                                isAIReport={true}
                                className="absolute top-0 mt-10 bg-black border border-gray-300 rounded-lg p-2"
                                style={{
                                    zIndex: 1000
                                }}
                            />
                            <Selector
                                key="Status"
                                options={[
                                    { name: "All", value: "All" },
                                    { name: "Completed", value: "Completed" },
                                    { name: "Failed", value: "Failed" },
                                ]}
                                label="Status"
                                value={selectedStatus}
                                onSelect={handleStatusSelect}
                                placeholder="Status"
                                isAIReport={true}
                                className="absolute top-0 mt-10 bg-black border border-gray-300 rounded-lg p-2"
                                style={{
                                    zIndex: 1000
                                }}
                            />

                            <Selector
                                key="Duration"
                                options={[
                                    { name: "Last 30 mins", value: "Last 30 mins" },
                                    { name: "Last 1 hour", value: "Last 1 hour" },
                                    { name: "Last 4 hours", value: "Last 4 hours" },
                                    { name: "Last 24 hours", value: "Last 24 hours" },
                                    { name: "Last 7 days", value: "Last 7 days" },
                                ]}
                                label="Duration"
                                value={selectedDateFilter}
                                onSelect={handleDateFilterSelect}
                                placeholder="Duration"
                                isAIReport={true}
                                className="absolute top-0 mt-10 bg-black border border-gray-300 rounded-lg p-2"
                                style={{
                                    zIndex: 1000
                                }}
                            />      
                            {/* <DatePicker className='date-picker-container' selected={selectedDate} onChange={(date) => handleDateChange(date)}   /> */}

                            <p className='p-2 border border-gray-700 p-2 font-bolt'
                                style={{ height: 40, color: 'rgb(254, 0, 0)', fontWeight: 700 }}
                            >No. of Jobs Failed : {failedCount}</p>


                        </div>
                        <div className='justify-end self-end right-[50px] z-0'>
                            <Button
                                onClick={() => handleSearch()}
                                size="small"
                                style={{ width: 90, marginRight: 0, height: 40, backgroundColor: 'rgb(51, 63, 72)', color: 'rgb(55, 231, 167)' }}
                            >
                                Search
                            </Button>
                            <Button
                                onClick={() => handleClearFilter()}
                                size="small"
                                style={{ width: 90, marginRight: 1, height: 40, backgroundColor: 'rgb(51, 63, 72)', color: 'rgb(55, 231, 167)' }}
                            >
                                Clear
                            </Button>
                        </div>


                    </div>
                </header>
                <Popup
                    show={showErrorPopup}
                    global={true}
                    fitContent={true}
                    emailPopup={true}
                >
                    <div className="p-4 pb-6 rounded-xl" style={{height: "auto !important"}}>
                                      <div className="flex justify-end">
                                        <CrossIcon className="cursor-pointer" onClick={() => setShowErrorPopup(false)} />
                                      </div>
                                      <p className="text-black font-semibold inline-block mt-2 px-4">
                                        <p className="text-sm text-center">{selectedErrorMessage ? selectedErrorMessage : "No Message Found"}</p>
                                      </p>
                    </div>
                </Popup>
                <div className="overflow-y-auto h-96">
                    <table className="table-css border-current border-white text-center w-[100%]">
                        <thead className="sticky top-0 bg-white">
                            <tr>
                                <th className="py-2 px-4 border-b text-black text-left">Job Name</th>
                                {/* Show Failed Count column header only for failed jobs */}
                                {failedCount > 0 && <th className="py-2 px-4 border-b text-black">Failed Count</th>}
                                <th className="py-2 px-4 border-b text-black">Region</th>
                                <th className="py-2 px-4 border-b text-black">Job Start Date</th>
                                <th className="py-2 px-4 border-b text-black">Job End Date</th>
                                <th className="py-2 px-4 border-b text-black">Job Status</th>
                                <th className="py-2 px-4 border-b text-black">FileName</th>
                                <th className="py-2 px-4 border-b text-black">Error Message</th>
                                <th className="py-2 px-4 border-b text-black">Action</th>
                            </tr>
                        </thead>
                        <tbody className='table-data overscroll-contain ant-table-tbody'>
                            {!isEmpty(uniqueJobNameData) ? uniqueJobNameData?.map((item, index) => {
                                const isFailed = item["JobStatus"]?.toLowerCase()?.includes('failed');
                                // Only show expand/collapse and Failed Count for failed jobs
                                if (!isFailed) {
                                    return (
                                        <tr key={index} className={`text-black hover:bg-black-200 ant-table-row row-default`}>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover text-left">{item.JobName}</td>
                                            {/* Only render Failed Count cell if header is present */}
                                            {failedCount > 0 && <td className="py-2 px-4 border-b ant-table-cell-row-hover">-</td>}
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{item.Region}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{moment(item.JobStartDate).format("YYYY-MM-DD HH:mm:ss A")}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{moment(item.JobEndDate).format("YYYY-MM-DD HH:mm:ss A")}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{item.JobStatus}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{item.FileName}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">
                                                {isFailed ? (
                                                    <span className="text-red underline cursor-pointer" onClick={()=>handleViewError(item)}>View</span>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            <td className="px-4 py-2 border-b border-gray-200 text-center ant-table-cell-row-hover">
                                                {isFailed && item?.IsRetriggered === "0" ? (
                                                    <span className="text-red underline cursor-pointer" onClick={()=>handleRetrigger(item)}>Retrigger</span>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        </tr>
                                    );
                                }
                                // For failed jobs, show expand/collapse and Failed Count
                                const isExpandable = jobNameCounts[item.JobName] > 1;
                                const isExpanded = expandedJobNames.includes(item.JobName);
                                return (
                                    <React.Fragment key={index}>
                                        <tr className={`text-black hover:bg-black-200 ant-table-row row-failed`} style={{ color: 'red !important' }}>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover text-left">
                                                {isExpandable ? (
                                                    <span
                                                        className="cursor-pointer mr-2"
                                                        onClick={() => handleToggleExpand(item.JobName)}
                                                        style={{ display: 'inline-block', transform: isExpanded ? 'rotate(90deg)' : 'rotate(0deg)', transition: 'transform 0.2s' }}
                                                        aria-label={isExpanded ? 'Collapse' : 'Expand'}
                                                >
                                                        &#9654;
                                                    </span>
                                                ) : (
                                                    <span className="mr-2">-</span>
                                                )}
                                                {item.JobName}
                                            </td>
                                            {/* Show Failed Count cell only for failed jobs */}
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{jobNameCounts[item.JobName]}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{item.Region}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{moment(item.JobStartDate).format("YYYY-MM-DD HH:mm:ss A")}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{moment(item.JobEndDate).format("YYYY-MM-DD HH:mm:ss A")}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{item.JobStatus}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">{item.FileName}</td>
                                            <td className="py-2 px-4 border-b ant-table-cell-row-hover">
                                                <span className="text-red underline cursor-pointer" onClick={()=>handleViewError(item)}>View</span>
                                            </td>
                                            <td className="px-4 py-2 border-b border-gray-200 text-center ant-table-cell-row-hover">
                                                {item?.IsRetriggered === "0" ? (
                                                    <span className="text-red underline cursor-pointer" onClick={()=>handleRetrigger(item)}>Retrigger</span>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        </tr>
                                        {/* Expanded rows for jobs with the same name (only for failed jobs) */}
                                        {isExpandable && isExpanded && filterData.filter(j => j.JobName === item.JobName && j["JobStatus"]?.toLowerCase()?.includes('failed')).map((job, idx) => {
                                            // Skip the first (main) row, already rendered above
                                            // if (job.JobStartDate === item.JobStartDate && job.JobEndDate === item.JobEndDate && job.Region === item.Region) return null;
                                            return (
                                                <tr key={idx + '-expanded'} className="bg-gray-100 text-black ant-table-row expanded-row">
                                                    <td className="py-2 px-4 border-b ant-table-cell-row-hover pl-8 text-left">{job.JobName}</td>
                                                    {/* Show Failed Count cell only for failed jobs */}
                                                    <td className="py-2 px-4 border-b ant-table-cell-row-hover">{jobNameCounts[job.JobName]}</td>
                                                    <td className="py-2 px-4 border-b ant-table-cell-row-hover">{job.Region}</td>
                                                    <td className="py-2 px-4 border-b ant-table-cell-row-hover">{moment(job.JobStartDate).format("YYYY-MM-DD HH:mm:ss A")}</td>
                                                    <td className="py-2 px-4 border-b ant-table-cell-row-hover">{moment(job.JobEndDate).format("YYYY-MM-DD HH:mm:ss A")}</td>
                                                    <td className="py-2 px-4 border-b ant-table-cell-row-hover">{job.JobStatus}</td>
                                                    <td className="py-2 px-4 border-b ant-table-cell-row-hover">{job.FileName}</td>
                                                    <td className="py-2 px-4 border-b ant-table-cell-row-hover">
                                                        <span className="text-red underline cursor-pointer" onClick={()=>handleViewError(job)}>View</span>
                                                    </td>
                                                    <td className="px-4 py-2 border-b border-gray-200 text-center ant-table-cell-row-hover">
                                                        {job?.IsRetriggered === "0" ? (
                                                            <span className="text-red underline cursor-pointer" onClick={()=>handleRetrigger(job)}>Retrigger</span>
                                                        ) : (
                                                            "-"
                                                        )}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </React.Fragment>
                                );
                            }) : "No Data Found"}

                         </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};

export default JobMonitoringTable;